<template>
  <div class="thank-you-container">
    <div class="content-wrapper">
      <div class="starry-decoration">
        <img src="@website-assets/img/starry.png" alt="" />
      </div>

      <div class="main-content">
        <div class="success-icon">✓</div>

        <h1 class="title">{{ $t('exclusiveOffer.thanks-title') }}</h1>
        <p class="message">{{ $t('exclusiveOffer.thanks-message') }}</p>

        <div class="cta-section">
          <button
            class="btn btn-primary btn-L"
            @click="goToOffers"
          >
            {{ $t('exclusiveOffer.thanks-cta') }}
          </button>
        </div>
      </div>

      <footer class="footer-links">
        <a href="/">{{ $t('exclusiveOffer.offers-back') }}</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  methods: {
    goToOffers() {
      this.$router.push('/offre-exclusive/offres');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/vars/index";

.thank-you-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.content-wrapper {
  max-width: 700px;
  width: 100%;
  position: relative;
  z-index: 2;
}

.starry-decoration {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.1;
  width: 100%;
  max-width: 800px;
  height: auto;
  pointer-events: none;
  z-index: 1;

  img {
    width: 100%;
    height: auto;
  }
}

.main-content {
  background: white;
  border-radius: 30px;
  padding: min(4rem, 8vw);
  box-shadow: 0px 10px 40px rgba(77, 160, 255, 0.15);
  text-align: center;
  position: relative;
  z-index: 2;
}

.success-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 2rem;
  background: linear-gradient(135deg, #4DA0FF 0%, #7B4FD4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: white;
  font-weight: bold;
  animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.title {
  font-family: "Baloo 2", sans-serif;
  font-size: min(2.5rem, 7vw);
  font-weight: 700;
  color: #4da0ff;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.message {
  font-family: "Baloo 2", sans-serif;
  font-size: min(1.3rem, 4vw);
  color: #666;
  line-height: 1.6;
  margin-bottom: 3rem;
}

.cta-section {
  display: flex;
  justify-content: center;
  align-items: center;

  .btn {
    font-size: min(1.5rem, 5vw);
    padding: 1.2rem 2rem;
    width: 100%;
    max-width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
  }

  @media (min-width: 768px) {
    .btn {
      font-size: 1.5rem;
    }
  }
}

.footer-links {
  text-align: center;
  margin-top: 2rem;

  a {
    font-family: "Baloo 2", sans-serif;
    color: #7B4FD4;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s ease;

    &:hover {
      color: #4da0ff;
    }
  }
}

@media (max-width: 768px) {
  .thank-you-container {
    padding: 1rem;
  }

  .main-content {
    padding: 2rem 1.5rem;
  }

  .success-icon {
    width: 80px;
    height: 80px;
    font-size: 2.5rem;
  }
}
</style>
